// extracted by mini-css-extract-plugin
module.exports = {"container":"_7c1dedd","border":"_faa17e1","fitContent":"_1ba0bd2"};